"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormInputPasswordField = void 0;

var _react = _interopRequireDefault(require("react"));

var _error = require("../error");

var _label = require("../label");

var _inputPassword = require("./input-password");

var _input = require("./input.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormInputPasswordField = function FormInputPasswordField(_ref) {
  var m = _ref.m,
      mt = _ref.mt,
      mr = _ref.mr,
      mb = _ref.mb,
      ml = _ref.ml,
      p = _ref.p,
      pt = _ref.pt,
      pr = _ref.pr,
      pb = _ref.pb,
      pl = _ref.pl,
      labelType = _ref.labelType,
      props = _objectWithoutProperties(_ref, ["m", "mt", "mr", "mb", "ml", "p", "pt", "pr", "pb", "pl", "labelType"]);

  return /*#__PURE__*/_react.default.createElement(_input.FormInputFieldWrapStyled, {
    m: m,
    mt: mt,
    mr: mr,
    mb: mb,
    ml: ml,
    p: p,
    pt: pt,
    pr: pr,
    pb: pb,
    pl: pl
  }, props.label && /*#__PURE__*/_react.default.createElement(_label.FormLabel, {
    type: labelType,
    required: props.required
  }, props.label), /*#__PURE__*/_react.default.createElement(_inputPassword.FormInputPassword, props), /*#__PURE__*/_react.default.createElement(_error.FormError, {
    name: props.name
  }));
};

exports.FormInputPasswordField = FormInputPasswordField;
FormInputPasswordField.defaultProps = {
  measure: 'md',
  disabled: false,
  required: false,
  placeholder: 'Enter'
};
FormInputPasswordField.displayName = 'FormInputField';
FormInputPasswordField.Style = _input.FormInputStyled;